import { ready } from "./utils";
import { cherrySliders } from "./sliders";
import { TeamBlockModal } from "./modals";

ready(() => {
  cherrySliders();
  TeamBlockModal();
});
